<div class="modal fade modal--alert" id="onboarding-modal" tabindex="-1" role="dialog" aria-labelledby="onboarding-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-onboarding">
      <div class="modal-onboarding__content">
        <div class="container">
          <div id="onboarding-slider" class="modal-onboarding__slider">

            <div class="modal-onboarding__slide">
              <div class="modal-onboarding__img">
                <picture>

                  <source media="(min-width:540px)" srcset="/assets/img/onboarding/tour-start.png" />
                  <source srcset="/assets/img/onboarding/tour-start-mobile.png" />
                  <img src="/assets/img/onboarding/tour-start.png" alt="" class="img-fluid" />
                </picture>
              </div>

              <div class="rte">
                <h3>Welcome to Everything.Insure!</h3>
                <p>Our all-in-one insurance platform will empower you to <strong>understand</strong> and <strong>control</strong> all your cover in one place.</p>
              </div>
            </div>

            <div class="modal-onboarding__slide">
              <div class="modal-onboarding__img modal-onboarding__img--square">
                <picture>
                  <source media="(min-width:540px)" data-srcset="/assets/img/onboarding/animation-quotes.gif" />
                  <source data-srcset="/assets/img/onboarding/animation-quotes-mobile.gif" />
                  <img data-src="/assets/img/onboarding/animation-quotes.gif" alt="" class="img-fluid lazyload" />
                </picture>
              </div>

              <div class="rte">
                <h3>Get quotes and buy instantly</h3>
                <p>Get multiple comparative quotes, from personal to professional and business insurance, from the top insurers. Get access to the best products at the best prices.</p>
              </div>
            </div>

            <div class="modal-onboarding__slide">
              <div class="modal-onboarding__img modal-onboarding__img--square">
                <picture>

                  <source media="(min-width:540px)" data-srcset="/assets/img/onboarding/animation-policies.gif" />
                  <source data-srcset="/assets/img/onboarding/animation-policies-mobile.gif" />
                  <img data-src="/assets/img/onboarding/animation-policies.gif" alt="" class="img-fluid lazyload" />
                </picture>
              </div>

              <div class="rte">
                <h3>Manage your policies</h3>
                <p>Manage and adjust all your policies in one place. Customise your policy to your budget and needs.</p>
              </div>
            </div>



            <div class="modal-onboarding__slide">
              <div class="modal-onboarding__img modal-onboarding__img--square">
                <picture>
                  <source media="(min-width:540px)" data-srcset="/assets/img/onboarding/animation-claims.gif" />
                  <source data-srcset="/assets/img/onboarding/animation-claims-mobile.gif" />
                  <img data-src="/assets/img/onboarding/animation-claims.gif" alt="" class="img-fluid lazyload" />
                </picture>
              </div>

              <div class="rte">
                <h3>File quick claims</h3>
                <p>Claiming is quick and easy. You can submit a claim online anytime, anywhere. Stay up-to-date with the status of your claims in real-time.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-onboarding__tray">
        <div class="container">
          <div class="modal-onboarding__tray-left">
            <div class="modal-onboarding__tray-count"><span id="onboarding-count">1</span> / <span>4</span></div>
            <a href="#" data-dismiss="modal" (click)="acceptOrSkip()">Skip</a>
          </div>
          <div class="modal-onboarding__tray-right">
            <a href="#" id="onboarding-next" class="button button--lg button--primary">Get Started</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
